/* eslint-disable @typescript-eslint/no-magic-numbers */
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'

import { Badge } from '@components/Badge'
import Ticket from '@components/Ticket'
import { IInventoryItem } from '@types'

import { InventorySelectedItemStyled, InventorySelectedItemTitle } from './index.style'

interface IInventorySelectedItemProperties {
    item: IInventoryItem
}

export const InventorySelectedItem: FC<IInventorySelectedItemProperties> = properties => {
    const [assetUrl, setAssetUrl] = useState('')

    const itemAsset = useMemo(
        () => (properties.item.nft.animationUrl ? properties.item.nft.animationUrl : properties.item.nft.image),
        [properties.item],
    )

    const changeAsset = useCallback(async () => {
        setAssetUrl('')
        await new Promise(resolve => setTimeout(resolve, 0.1))
        setAssetUrl(itemAsset)
    }, [itemAsset])

    useEffect(() => {
        changeAsset()
    }, [changeAsset])

    return (
        <InventorySelectedItemStyled>
            <InventorySelectedItemTitle>
                <div>{properties.item.nft.name}</div>
                <Badge variant="#F4F2FF" textColor="#6750d5">
                    # {properties.item.nft.tokenId}
                </Badge>
            </InventorySelectedItemTitle>
            {assetUrl && <Ticket assetUrl={assetUrl} />}
        </InventorySelectedItemStyled>
    )
}
